module.exports = __webpack_public_path__ + "static/media/parking.12902deb.svg";